import nativeHelper from "@/lib/nativeHelper.ts"
import { recordEventToHotjar } from "@/plugins/hotjar/hotjar.ts"
import { CookieConsentService } from "@/services/shared/cookieConsent/CookieConsentPlugin"
import { NavigationHookAfter } from "vue-router"

export const nativeHotjarInitEventHook: NavigationHookAfter = () => {
  CookieConsentService.runOnceCookieCategoryAccepted("marketing", () => {
    if (nativeHelper.isNative() && !!window) {
      // this event is used by hotjar to display surveys specific to the mobile app
      // if we emit it too quickly, it fails to register so we're giving it half a second.
      // We need to emit it on every navigation or else the surveys will only show once
      // and disappear as soon as the page changes
      setTimeout(() => recordEventToHotjar("nativeAppInit"), 500)
    }
  })
}
